import { shopeeEnvironment, cid, getEnvAtRuntime, getCidAtRuntime } from './env.mjs';

/**
 * @module @mkt-common/shopee-common
 */
const BASE_DOMAIN_SUFFIX = {
    sg: 'shopee.sg',
    my: 'shopee.com.my',
    th: 'shopee.co.th',
    tw: 'shopee.tw',
    vn: 'shopee.vn',
    id: 'shopee.co.id',
    ph: 'shopee.ph',
    br: 'shopee.com.br',
    mx: 'shopee.com.mx',
    co: 'shopee.com.co',
    cl: 'shopee.cl',
    xx: 'shopee.systems',
};
/** @deprecated
 * 请使用 `BASE_DOMAIN_SUFFIX` 替换
 */
const BASE_DOMAIN_ALL = BASE_DOMAIN_SUFFIX;
/**
 * @deprecated
 * shopeegame 域名已被回收
 */
const GAME_THIRD_PARTY_BASE_DOMAIN_ALL = {
    sg: 'shopeegame.sg',
    my: 'shopeegame.com.my',
    th: 'shopeegame.in.th',
    tw: 'shopeegame.tw',
    vn: 'shopeegame.vn',
    id: 'shopeegame.co.id',
    ph: 'shopeegame.ph',
    br: 'shopeegame.com.br',
};
const MALL_SUBDOMAIN_PREFIX = 'mall.';
const GAMES_SUBDOMAIN_PREFIX = 'games.';
const SELLER_SUBDOMAIN_PREFIX = {
    sg: 'seller.',
    my: 'seller.',
    th: 'seller.',
    tw: 'seller.',
    vn: 'banhang.',
    id: 'seller.',
    ph: 'seller.',
    br: 'seller.',
    mx: 'seller.',
    co: 'seller.',
    cl: 'seller.',
};
const domainPrefix = shopeeEnvironment === 'live' ? '' : shopeeEnvironment === 'liveish' ? 'live-test.' : `${shopeeEnvironment}.`;
function getBaseDomain(e = shopeeEnvironment, c = cid) {
    const prefix = e === 'live' ? '' : e === 'liveish' ? 'live-test.' : `${e}.`;
    return `${prefix}${BASE_DOMAIN_SUFFIX[c]}`;
}
const getBaseDomainAtRuntime = () => {
    // 使用 '' 兜底, 是为了不让 getBaseDomain 使用默认值
    // 如果运行时无法获取 env cid 就及时报错
    const env = getEnvAtRuntime() || '';
    const region = getCidAtRuntime() || '';
    return getBaseDomain(env, region);
};
const BASE_DOMAIN = /*#__PURE__*/ getBaseDomain();
const MALL_HOST =  `https://${MALL_SUBDOMAIN_PREFIX}${domainPrefix}${BASE_DOMAIN_SUFFIX[cid]}`;
const SELLER_HOST =  `https://${SELLER_SUBDOMAIN_PREFIX[cid]}${domainPrefix}${BASE_DOMAIN_SUFFIX[cid]}`;
const GAMES_HOST =  `https://${GAMES_SUBDOMAIN_PREFIX}${domainPrefix}${BASE_DOMAIN_SUFFIX[cid]}`;
const GAMES_THIRD_PARTY_HOST =  `https://${GAMES_SUBDOMAIN_PREFIX}${domainPrefix}${GAME_THIRD_PARTY_BASE_DOMAIN_ALL[cid]}`;

export { BASE_DOMAIN, BASE_DOMAIN_ALL, BASE_DOMAIN_SUFFIX, GAMES_HOST, GAMES_THIRD_PARTY_HOST, GAME_THIRD_PARTY_BASE_DOMAIN_ALL, MALL_HOST, SELLER_HOST, getBaseDomain, getBaseDomainAtRuntime };
